export default class Accordeon {
    constructor($element) {
        this.$element = $element;
        this.$items = this.$element.querySelectorAll('[data-accordeon-item]');

        this.open = this.open.bind(this);

        this.$items.forEach($trigger => $trigger.addEventListener('click', this.open));
    }

    open(e) {
        const item = e.target.closest('[data-accordeon-item]');

        if (item.classList.contains('faq-list__content-item--open')) {
            item.classList.remove('faq-list__content-item--open')
        }
        else {
            this.$items.forEach($item => $item.classList.remove('faq-list__content-item--open'));
            item.classList.add('faq-list__content-item--open')
        }

    }
}